<template>
    <component
        :is="tag"
        v-if="show"
        class="max-tablet:text-xl max-tablet:pt-12 font-normal_light absolute flex size-full justify-center pt-52 text-center text-3xl uppercase text-gray-800"
    >
        <slot>{{ displayedMessage }}</slot>
    </component>
</template>
<script setup lang="ts">
import { getStrByLng } from "@swisstiming/webtec-kit";
import { computed, onMounted, onUnmounted, ref } from "vue";

const props = withDefaults(
    defineProps<{
        msg?: "no-event" | "no-data" | "no-access";
        tag?: string;
        delay?: number;
    }>(),
    {
        tag: "div",
        delay: 250
    }
);

const displayedMessage = computed(() => {
    switch (props.msg) {
        case "no-event":
            return getStrByLng().MESSAGE_NO_EVENT_AVAILABLE;
        case "no-data":
            return getStrByLng().MESSAGE_NO_DATA_AVAILABLE;
        case "no-access":
            return getStrByLng().NO_ACCESS_MESSAGE;
    }
    return undefined;
});

let tId: number;
const show = ref(false);

onMounted(() => {
    tId = window.setTimeout(() => {
        show.value = true;
    }, props.delay);
});

onUnmounted(() => {
    clearTimeout(tId);
});
</script>

<style lang="scss"></style>
